import type { TFiberType } from '@/lib/api/SportsbookSocketManager';

type TSocketEmitterAggregateItem = {
  action: 'join' | 'leave';
  model: TFiberType;
  ids?: string[];
};

export const socketEmitterAggregate = <T extends TSocketEmitterAggregateItem>(items: T[]): T[] => {
  const map = new Map<string, { join: Set<string>; leave: Set<string> }>();

  for (const { model, action, ids = [] } of items) {
    let sets = map.get(model);

    if (!sets) {
      sets = { join: new Set(), leave: new Set() };
    }

    for (const id of ids) {
      if (action === 'join') {
        sets.leave.delete(id);
        sets.join.add(id);
      } else {
        sets.join.delete(id);
        sets.leave.add(id);
      }
    }

    map.set(model, sets);
  }

  const result: T[] = [];

  for (const [model, { join, leave }] of map) {
    if (join.size) {
      result.push({
        action: 'join',
        ids: Array.from(join),
        model,
      } as T);
    }

    if (leave.size) {
      result.push({
        action: 'leave',
        ids: Array.from(leave),
        model,
      } as T);
    }
  }

  return result;
};
